import {GenericHomepageElementTypes, HomepageElement} from '../homepage'
import {allTimeRanges} from '../widget-points-leaderboard/indexWidget'
import {Tab} from '../homepage-tabs/TabsConfigurator'
import {TypesThatCanBeAdded} from './new-button'

export const getDefaultWidget = (type: TypesThatCanBeAdded, id: number): HomepageElement => {
  const sharedDefault = {
    active: true,
    id
  }
  switch (type) {
    case 'html_widget':
      return Object.assign({}, sharedDefault, {
        type,
        title: '',
        config: {
          html: ''
        }
      })
    case 'badges':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Badges',
        config: {
          amount: 5
        }
      })
    case 'tag_cloud':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Popular tags',
        config: {
          amount: 5
        }
      })
    case 'leaderboard_points':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'User leaderboard',
        config: {
          maxResults: 5,
          excludeUserRole: [],
          timeRange: allTimeRanges,
          emptyMessage: '',
          isPreviewEmptyMessage: false
        }
      })
    case 'event_calendar':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Events Calendar',
        config: {
          amount: 5
        }
      })
    case 'solved_topics':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Solved topics',
        config: {
          amount: 5
        }
      })
    case 'most_liked':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Most Liked',
        config: {
          amount: 5,
          period: 7
        }
      })
    case 'community_statistics':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Community Statistics',
        config: {
          total_topics: true,
          total_comments: true,
          total_users: true
        }
      })
    case 'quick_links':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Quick links',
        config: {
          borderRadius: 3,
          enableBorder: true,
          quickLinks: []
        }
      })
    case 'recommendations':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Recommendations',
        config: {
          curatedTopics: []
        }
      })
    case 'featured_topics':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Featured Topics',
        config: {
          topics: [],
          firstTopicsNumber: 1,
          buttonLabel: '',
          buttonURL: ''
        }
      })
    case GenericHomepageElementTypes.feature_topics:
      return Object.assign({}, sharedDefault, {
        type,
        config: {}
      })
    case 'category_and_topics_stream_only':
      const tabs: Array<Tab> = [{
        'phrase_suffix': 'categories',
        'enabled': true,
        'class': '_index-forums',
        'collapsed': true,
        'phrase': 'Categories'
      }, {
        'phrase_suffix': 'unanswered',
        'enabled': true,
        'class': 'branded/_index-unanswered-topics',
        'collapsed': false,
        'phrase': 'Help others'
      }, {
        'phrase_suffix': 'recent_active',
        'enabled': true,
        'class': 'branded/_index-recent-topics',
        'collapsed': false,
        'phrase': 'Recently active'
      }]
      return Object.assign({}, sharedDefault, {
        type,
        title: '',
        config: {
          tabs: tabs
        }
      })
    case 'container_2_1':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Container 2:1',
        config: {
          column_1: [],
          column_2: []
        }
      })
    case GenericHomepageElementTypes.announcement_card:
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Announcement Card',
        config: {}
      })
    case GenericHomepageElementTypes.introduction_bar:
      return Object.assign({}, sharedDefault, {
        type,
        title: '',
        nonConfigurable: true,
        config: {}
      })
    case GenericHomepageElementTypes.statistics_bar:
      return Object.assign({}, sharedDefault, {
        type,
        title: '',
        nonConfigurable: true,
        config: {}
      })
    case 'hero_banner':
      return Object.assign({}, sharedDefault, {
        type,
        title: '',
        config: {
          heroImage: '',
          headline: ''
        }
      })
    case 'knowledge_base':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Knowledge Base',
        config: {
          selectedTemplate: 0
        }
      })
    case 'community_category':
      return Object.assign({}, sharedDefault, {
        type,
        title: 'Community Categories',
        config: {
          selectedTemplate: 0
        }
      })
  }
}
